function FacebookModule () {
  var self = this

  self.user = ko.observable(null)
  self.loading = ko.observable(false)
  self.image = ko.observable(null)
  self.registerType = ko.observable(null)
  self.invitationCode = ko.observable(null)

  self.redirectCallback = function (redirectUrl) {
    location.href = redirectUrl
  }

  self.login = function () {
    FB.login(function (response) {
      self.facebookLoginCallback(response)
    }, { scope: 'public_profile, email' })
  }

  self.facebookLoginCallback = function (response) {
    var accessToken
    var userId

    if (response.status === 'connected') {
      accessToken = response.authResponse.accessToken
      userId = response.authResponse.userID
    } else if (response.type === 'facebook') {
      accessToken = response.accessToken
      userId = response.userId
    }
    if (accessToken) {
      self.setUser(accessToken, userId, function (response) {
        self.redirectCallback(response.data.url ? response.data.url : '/');
      })
    } else {
      debugLog('facebook missing access token')
      pNotify('Non hai autorizzato completamente facebook oppure prova a cancellare la cache e riprovare', 'warning')
      console.log('User cancelled login or did not fully authorize.')
    }
  }

  self.setUser = function (accessToken, userId, onSuccess) {
    var url = '/me?fields=email,id,first_name,last_name,picture'
    if (userId)
      url = '/' + userId + '?fields=email,id,first_name,last_name,picture'

    FB.api(url, 'GET', {
      access_token: accessToken,
    }, function (response) {

      if (response.error) {
        throw new Error(response);
      }

      var payload = {
        id: response.id,
        email: response.email,
        first_name: response.first_name,
        last_name: response.last_name,
        provider_type: 'facebook',
        accessToken: accessToken,
        type: self.registerType(),
        invitationCode: self.invitationCode()

      }

      rest('POST', '/api/v2/facebook/bind', payload)
        .then(function (response) {
          if (response.success) {
            self.user(response.data)
            pNotify('Accesso riuscito, attendi...', 'success')
            trovacigusto.loginRegisterModule.onesignalGetData()
          } else {
            pNotify('Il tuo account Facebook non è stato collegato.', 'warning')
          }
          self.loading(false)
          onSuccess(response)
        })
        .catch(function (res) {
          debugLog(res)
          pNotify('Accesso non riuscito prova un altro metodo', 'warning')
        })
    })
  }

  self.logout = function () {
    FB.logout(function (response) {
      pNotify('Logout da facebook prova di nuovo ad accedere', 'warning')
      console.info('User canceled login or did not fully authorize.')
    })
  }

  self.checkStatus = function () {
    FB.getLoginStatus(function (response) {
      if (response.status === 'connected') {
        if (response.authResponse) {
          self.setUser(response.authResponse.accessToken, response.authResponse.userID, function (response) {
            self.redirectCallback(response.data.url ? response.data.url : '/');
          })
        }
      } else {
        self.login()
      }
    })
  }

  self.unbindUser = function () {
    self.loading(true)
    rest('GET', '/api/v2/facebook/unbind')
      .then(function (response) {
        if (response.status === 'user.reset.password') {
          self.user(null)
          pNotify('Il tuo account Facebook è stato scollegato con successo. Se ancora non hai ancora creato una password devi impostarne una per poter accedere a Trovacigusto senza Facebook', 'warning')
        }
        self.loading(false)
      })
      .catch(function () {
        self.loading(false)
        pNotify('Si è verificato un errore. Prova a ricaricare la pagina e/o riprova più tardi', 'error')
      })
    self.logout()
  }

  self.bindUser = function () {
    FB.getLoginStatus(function (response) {
      self.facebookLoginCallback(response, function (response) {
        if (response)
          window.location.href = response
      })
    })

  }

  self.bindPicture = function () {
    FB.login(function (response) {
      if (response.authResponse) {
        FB.api('/me/picture?height=500&width=500&redirect=false', function (response) {
          if (!response.error) {
            self.loading(true)
            rest('POST', '/api/v2/facebook/image', { data: response.data })
              .then(function (response) {
                if (response.success) {
                  self.image({ uri: response.data.image.uri })
                } else {
                  pNotify('Si è verificato un errore durante il collegamento con Facebook. Prova a scollegarti e accedere di nuovo con Facebook', 'warning')
                }
                self.loading(false)
              })
          } else {
            pNotify('Si è verificato un errore durante il collegamento con Facebook. Prova a scollegarti e accedere di nuovo con Facebook', 'warning')
          }
        })
      }
    })
  }

  return self
}